import React from 'react';
import { SALARY_DUE_DAY_OPTIONS } from '../utils/salaryDueDay';

export default function SalaryDueDaySelect({ value, onChange, className = '', id }) {
  return (
    <div>
      <select
        id={id}
        value={value == null ? '' : String(value)}
        onChange={(event) => onChange(event.target.value)}
        className={className}
      >
        <option value="" disabled>Select due day</option>
        {SALARY_DUE_DAY_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
      <p className="mt-1 text-[11px] text-gray-400">
        Last day automatically means Feb 28/29, day 30 in 30-day months, and day 31 otherwise.
      </p>
    </div>
  );
}
